//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "wechat_tip",
}



// WEBPACK FOOTER //
// ./src/components/Wechat_error.vue